var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('package-transfer-receipt-print',{attrs:{"selectedPatient":_vm.selectedPatient,"patientConfig":_vm.patient,"generalConfig":_vm.general,"selectedPackage":_vm.selectedPackage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }